import * as d3 from "d3";
export class BaseCodec {
    constructor() { }
    encode(decodedValue) {
        return [decodedValue];
    }
    decode(encodedValue, index = 0) {
        return encodedValue[index] != null
            ? this._decode(encodedValue[index])
            : null;
    }
    _decode(encodedValue) {
        return encodedValue;
    }
    encodeSize() {
        return 1;
    }
    domain() {
        return undefined;
    }
    interpolationPreprocessor(_startValue) {
        return (v) => v;
    }
    postProcessSpline(bc) {
        return [bc];
    }
    spline(s1, s0, e0, e1, pointTiming //the duration to use when only one point is defined
    ) {
        if (s0 !== undefined || e0 !== undefined) {
            //at least s0 or e0 should be defined
            const preprocess = this.interpolationPreprocessor(s0 !== undefined ? s0.v : e0.v);
            let bc;
            let cp;
            if (s1 === undefined && e1 === undefined) {
                //only s0 or e0 has been defined
                if (s0 !== undefined && e0 !== undefined) {
                    //linear between s0 - e0
                    const t0 = s0.t;
                    const v0 = s0.v;
                    const t1 = e0.t;
                    const v1 = preprocess(e0.v);
                    const cv0 = v0 + (v1 - v0) / 3;
                    const ct0 = t0 + (t1 - t0) / 3;
                    const cv1 = v1 + (v0 - v1) / 3;
                    const ct1 = t1 + (t0 - t1) / 3;
                    cp = [
                        { x: t0, y: v0 },
                        { x: ct0, y: cv0 },
                        { x: ct1, y: cv1 },
                        { x: t1, y: v1 },
                    ];
                    bc = { cp, length: 1.0 };
                }
                else if (s0 !== undefined) {
                    //single point s0
                    const t0 = s0.t;
                    const v0 = s0.v;
                    cp = [
                        { x: t0, y: v0 },
                        { x: t0 + pointTiming, y: v0 },
                        { x: t0, y: v0 },
                        { x: t0 + pointTiming, y: v0 },
                    ];
                    bc = { cp, length: 1.0 };
                }
                else if (e0 !== undefined) {
                    //single point e0
                    const t1 = e0.t;
                    const v1 = e0.v;
                    cp = [
                        { x: t1 - pointTiming, y: v1 },
                        { x: t1, y: v1 },
                        { x: t1 - pointTiming, y: v1 },
                        { x: t1, y: v1 },
                    ];
                    bc = { cp, length: 1.0 };
                }
                else {
                    throw new Error("All indices provided are undefined. Unable to create spline.");
                }
            }
            else if (s0 !== undefined && e0 !== undefined) {
                //s0 end e0 have been defined and at least s1 or e1 (or both)
                //bezier
                const preprocess = this.interpolationPreprocessor(s0.v);
                const ctx = new BezierCurveControlPointsCollector();
                const curveGenerator = d3.curveCatmullRom(ctx);
                curveGenerator.lineStart();
                if (s1 !== undefined)
                    curveGenerator.point(s1.t, preprocess(s1.v));
                curveGenerator.point(s0.t, s0.v);
                curveGenerator.point(e0.t, preprocess(e0.v));
                if (e1 !== undefined) {
                    curveGenerator.point(e1.t, preprocess(e1.v));
                }
                else {
                    curveGenerator.lineEnd();
                }
                const cps = ctx.getControlPoints();
                cp = cps[s1 === undefined ? 0 : 1];
                bc = { cp, length: 1.0 };
            }
            else {
                throw new Error("Both s0 and e0 should have been defined. Unable to create spline.");
            }
            return this.postProcessSpline(bc);
        }
        else {
            throw new Error("At least s0 or e0 should have been defined. Unable to create spline.");
        }
    }
}
class BezierCurveControlPointsCollector {
    _x;
    _y;
    _cps;
    constructor() {
        this._cps = [];
    }
    //move to a new section of the data set curve
    moveTo(x, y) {
        //console.log(`'moveTo called ${this._indexTracker}`);
        this._x = +x;
        this._y = +y;
    }
    closePath() {
        //console.log(`'closePath called ${this._indexTracker}`);
    }
    lineTo(x, y) {
        //console.log(`'lineTo called ${this._indexTracker}`);
        this.bezierCurveTo(x, y, this._x, this._y, x, y);
    }
    quadraticCurveTo(x1, y1, x, y) {
        //console.log(`'quadraticCurveTo called ${this._indexTracker}`);
        const xcp1 = this._x + (2 * (x1 - this._x)) / 3;
        const ycp1 = this._y + (2 * (y1 - this._y)) / 3;
        const xcp2 = x + (2 * (x1 - x)) / 3;
        const ycp2 = y + (2 * (y1 - y)) / 3;
        this.bezierCurveTo(xcp1, ycp1, xcp2, ycp2, x, y);
    }
    bezierCurveTo(x1, y1, x2, y2, x, y) {
        //console.log(`'bezierCurveTo called ${this._indexTracker}`);
        const cp = [
            { x: this._x, y: this._y },
            { x: x1, y: y1 },
            { x: x2, y: y2 },
            { x, y },
        ];
        this._cps.push(cp);
        this._x = x;
        this._y = y;
    }
    arcTo(x1, y1, x2, y2, r) {
        //console.log(`'arcTo called ${this._timeKeeper.getIndex()}`);
    }
    arc(x, y, r, a0, a1, ccw) {
        //console.log(`'arc called ${this._timeKeeper.getIndex()}`);
    }
    rect(x, y, w, h) {
        //console.log(`'rect called ${this._timeKeeper.getIndex()}`);
    }
    getControlPoints() {
        //console.log('getCurves', this._);
        const result = this._cps;
        this._cps = [];
        return result;
    }
}
